import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef, AfterViewChecked, ChangeDetectionStrategy } from '@angular/core';
import { AuthService, LocalStorageService, LoginService } from 'src/app/services';
import { SearchDisplayModel } from 'src/app/common/models/searchDisplayModel';
import { SearchService } from 'src/app/services/search.service';
import { ConnectionListService } from '../../services/shared-services/connection-list.service';
import { TokenService } from 'src/app/services/token.service';
import { LocalStorageModelType } from 'src/app/common/enum';
import { Subscription } from 'rxjs';

@Component({
    selector: 'haven-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent implements OnInit,AfterViewChecked {
  @Output() loggingOut = new EventEmitter();
  selectedConnectionId: string;
  subscription: Subscription;
  constructor(private authService: AuthService,
              public connectionService: ConnectionListService, private tokenService: TokenService, private loginService: LoginService,private cdr: ChangeDetectorRef,
              private localStorageService: LocalStorageService
             ) {
  }
  userName = '';

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.connectionService.setConnectionList();
    const user = this.authService.getClientUserData();
    const name = user.loggedInName;
    this.userName = name ? decodeURIComponent(name.replace(/\+/g, ' ')) : '';
    this.selectedConnectionId  = this.localStorageService.getLocalStorage(LocalStorageModelType.CONNECTION);

    this.subscription = this.connectionService.getSubject().subscribe((data) => {
      if (!this.selectedConnectionId)
        this.selectedConnectionId = this.connectionService.connectionGuid;
    });
  }

  logout() {
    this.loginService.logout().subscribe(
      (result) => {
        this.loggingOut.emit();
        this.authService.deleteCookies();
        this.authService.logout();
      }
    );
    this.localStorageService.clearLocalStorageByKeyName(LocalStorageModelType.CONNECTION);
  }

  onConnectionChange(connectionGuid: string) {
   this.connectionService.setSubject(connectionGuid);
   this.localStorageService.setLocalStorage(LocalStorageModelType.CONNECTION, connectionGuid);
  }
}
